import React, { useRef, useImperativeHandle, forwardRef } from 'react';

import PropTypes from 'prop-types';

import { GATSBY_IMAGE_MIME_TYPES } from 'components/modules/files/constants/mimetypes';
import { isValidImageType } from 'libs/files/files';

const propTypes = {
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  onFileTypeError: PropTypes.func,
  onChange: PropTypes.func,
};

const defaultProps = {
  accept: GATSBY_IMAGE_MIME_TYPES,
  multiple: false,
  onFileTypeError: () => null,
  onChange: () => null,
};

const FileInput = forwardRef(function FileInput(
  { accept, multiple, onFileTypeError, onChange },
  ref,
) {
  const fileInputRef = useRef(null);

  useImperativeHandle(ref, () => ({
    click: () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    },
  }));

  function onFileChange(e) {
    const file = e.target.files[0];
    if (!isValidImageType(file)) {
      onFileTypeError();
      return;
    }
    const newTarget = { ...e.target, files: e.target.files };
    onChange({ ...e, target: newTarget }, newTarget);
  }

  return (
    <input
      ref={fileInputRef}
      hidden
      type="file"
      onChange={onFileChange}
      accept={accept}
      multiple={multiple}
    />
  );
});

FileInput.propTypes = propTypes;
FileInput.defaultProps = defaultProps;

export default FileInput;
